/**
 * 运力资源--》车辆档案
*/

export default {
    add_car_ywy: ["84139"], // 202509051247290736067, 84139 车辆档案详情 新增 业务员
    // 202510221644382839009  运力资源-承运公司-修改 公司名字可以修改
    modify_carrier_company_name: ["99596"],
}

 